import React, { useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import Blogs from './Blogs';
import './Blogs.css';

const BlogsList = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="blogs-list-page">
      <Header />
      <div className='list-section'>
        <Blogs showHeading={true} showViewAll={false} />
      </div>
      <Footer />
    </div>
  );
};

export default BlogsList;
